import axios from 'axios';
import AutenticationService from '../../authservice.js';

import AccessiService from '../Accessi/AccessiApi.js';
class CancelloSrv {
  //{ nome: 'claudio', password: 'manno' }

  //   options = {
  //     method: action,
  //     body: JSON.stringify(datar),
  //     headers: {
  //       'Content-Type': 'application/json',
  //       token: token,
  //     },
  //   };
  // }
  // fetch(url, options)
  getOpenCancelloBasic = (dati) => {
    let BasicAuthHeader =
      //'Basic ' + window.btoa(dati.userid + ':' + dati.password);
      'Basic ' + window.btoa(AutenticationService.getToken());
    const qs = require('qs');

    //const url = 'https://192.168.1.26:8443/open';
    const url = AccessiService.getUrl() + '/open';
    return axios.post(url, qs.stringify(dati), {
      headers: {
        authorization: BasicAuthHeader,
        token: AutenticationService.getToken(),
      },
    });
  };
}

export default new CancelloSrv();
